import { Component, OnInit, ViewChild, ElementRef, Inject, Output, effect,ChangeDetectorRef, HostListener } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from "./../../../../environments/environment";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { QuotingToolService } from "../quoting-tool.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NotificationService } from "src/app/core/services/notification.service";
import { EditProject } from "src/app/core/interfaces/quoting-tool";
import { MatStepper } from '@angular/material/stepper';
import { SpecificationsComponent } from "./specifications/specifications.component";
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from "src/app/core/helper/helper.service";
import { AuthService } from "../../auth/auth.service";

interface ProjectDetails {
  iProjectID: string;
  vProjectName: string;
  vDescription: string;
}

@Component({
  selector: "app-stepper-forms",
  templateUrl: "./stepper-forms.component.html",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class StepperFormsComponent implements OnInit {
  @ViewChild('openeditProjectForm', { static: false })
  openeditProjectForm!: ElementRef;
  @ViewChild('dismisseditProjectForm', { static: false })
  dismisseditProjectForm!: ElementRef;

  @Output() updatepcbForm!: FormGroup;

  // @ViewChild(MatStepper) stepper!: MatStepper;
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild(SpecificationsComponent) specificationsComponent!: SpecificationsComponent;
  
  getImagePath: any = environment.image_path;
  memberDomain:any=environment.member_domain;
  isLinear = true;
  stepContent: string = "content-1";
  activeStepIndex: number = 0; // Track the active step inde
  projectID!: any;
  uniqueID!: any;
  projects: ProjectDetails = {
    iProjectID: '-',
    vProjectName: '-',
    vDescription: '-'
  }
  editProjectForm!: FormGroup;
  editProjectFormSubmitted = false;
  isFormInvalid: boolean = true;
  isLoading: boolean = false;
  projectId!: string;
  access_token!:any;
  isOnFinalStep = false;

  stepperNext = this.quotingService.getStepper();
  userDetails: any = [];

  constructor(private auth: AuthService,private helper: HelperService,private cdr: ChangeDetectorRef,private router: Router, private modalService: NgbModal, config: NgbModalConfig, private route: ActivatedRoute, private http: HttpClient, private quotingService: QuotingToolService,private authService: AuthenticationService , public dialog: MatDialog, private notificationService: NotificationService) { 
    history.pushState(null, '');
    const storedStepIndex = localStorage.getItem('currentStepIndex');
  if (storedStepIndex) {
    this.navigateToExistingStep(parseInt(storedStepIndex, 10));
  } else {
    this.navigateToStep(0); // Default to the first step if no stored index is found
  }
  
    effect(() => {
      const value = this.stepperNext();
      if(this.stepper){
      this.stepper.next();
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit(): void {
    if(this.route.snapshot.queryParamMap.get('manage') == '1'){
      if(localStorage.getItem('customer_access_token')){
        this.helper.ClearStorageData();
      }
      let token=this.route.snapshot.queryParamMap.get('quote_token');
      if(token){
        localStorage.setItem('quote_token',token);
      }
    }else{
      localStorage.removeItem('quote_token');
    }
    this.access_token = this.route.snapshot.queryParamMap.get('quote_token') ? this.route.snapshot.queryParamMap.get('quote_token') : localStorage.getItem('customer_access_token');
    if (this.access_token) {
      this.GetUserData();
    }
    this.projectID = this.route.snapshot.queryParamMap.get('projectID');
    this.uniqueID = localStorage.getItem('ID');
    if (this.projectID) {
      this.callApiBasedOnProjectType(this.projectID);
    }
    this.editProjectForm = new FormGroup({
      vProjectName: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')]),
      vDescription: new FormControl("", [Validators.required, Validators.maxLength(1000),Validators.pattern('^\\S.*$')])
    });
    if(this.access_token){
      this.GetProfileDetails();
    }

  }

  ngOnDestroy(){
    this.modalService.dismissAll();
  }

  onStepperBack(): void {
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0) {
      let newIndex=storedStepIndex-1;
      this.navigateToExistingStep(newIndex); // Go back in the stepper
    }else{
      this.router.navigate(['quotations']);
    }
  }


  flag:boolean=false;
  // Listen for the browser back event (popstate)
  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent): void {
    // Prevent the default browser back action
    event.preventDefault();
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0) {
      history.pushState(null, '');
      this.flag=true;

      // Trigger your custom "stepper back" behavior
      this.onStepperBack(); // Go back in the stepper
    }else{
    this.flag=false;
    window.location.href='/quotations';
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event): void {
    const storedStepIndex = Number(localStorage.getItem('currentStepIndex'));
    if (storedStepIndex > 0 && this.flag) {
      event.preventDefault(); // Prevent browser default unload behavior
      event.returnValue = false; // Required for some browsers to show confirmation prompt
    }else{
      event.returnValue = true;
    }
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }

  GetUserData() {
    this.authService.GetProfileData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.userDetails = resJSON.data;
      } else {
        this.notificationService.showError(`${resJSON.message}`, '');
      }
    });
  }

  isStepperFormsRoute(): boolean {
    const accessToken = this.route.snapshot.queryParamMap.get('quote_token') ? this.route.snapshot.queryParamMap.get('quote_token') : localStorage.getItem('customer_access_token');
    return this.router.url.includes('/m-quotation') && accessToken !== null;
  }

  ChangePassword() {
    let token=this.route.snapshot.queryParamMap.get('quote_token');
    if(token){
    window.close();
    window.open(this.memberDomain + `/member/change-password`, '_blank');
    }else{
      this.router.navigate(['/customer/change-password']);
    }
  } 

  HandleLogout() {
    let token=this.route.snapshot.queryParamMap.get('quote_token');
    if(token){
      this.auth.Logout().subscribe((result: any) => {
        if (result.code == 200) {
          this.notificationService.showSuccess('You have been successfully logged out!');
        }
      });
      this.helper.ClearStorageData();
      window.close();
      window.open(this.memberDomain, '_blank');
    }else{
      this.helper.Logout();
    }
  }

  getRoute() {
    const accessToken = localStorage.getItem('customer_access_token');
    if(accessToken){
      this.router.navigate(['/customer/quotation-proposal'])
    } else {
      let token=this.route.snapshot.queryParamMap.get('quote_token');
      if(token){
      window.close();
      window.open(this.memberDomain + `/member/quotation-proposal`, '_blank');
      }else{
        this.router.navigate([''])
      }
    }
  }

  projectType: any;
  callApiBasedOnProjectType(projectID: string) {
    this.quotingService
      .GetProjectDatabyID(projectID)
      .subscribe(async (resJSON: any) => {
        if (resJSON.code == 200) {
          this.PatchUserData();
          this.projects = {
            iProjectID: resJSON.data.iProjectID,
            vProjectName: resJSON.data.vProjectName,
            vDescription: resJSON.data.vDescription
          };
          this.projectType = resJSON.data.vProjectType;
          localStorage.setItem("projectID", resJSON.data.iProjectID);
          localStorage.setItem("projectType", resJSON.data.vProjectType);
          localStorage.setItem("ID", resJSON.data._id);
          if(resJSON.data.gerberFile && resJSON.data.gerberFile != null){
            localStorage.setItem("gerberFilePath",resJSON.data.gerberFile);
            let json =  JSON.stringify({"name":resJSON.data.gerberFile,"type":"gerber"});
            localStorage.setItem("gerberFile",json);
            localStorage.setItem('upload_gerber','true');
          }
          
          if(!this.uniqueID){
            localStorage.setItem("projectID", resJSON.data.iProjectID);
            localStorage.setItem("projectType", resJSON.data.vProjectType);
            localStorage.setItem("ID", resJSON.data._id);
            this.notificationService.showInfo("Initializing...","")
            location.reload()
          }
          
          this.PatchUserData();
        } else {
        }
      });
  }

  EditProjectDetailsModal(ModalName: any){
    this.modalService.open(ModalName, { centered: true, windowClass: 'edit-custom-modal', size: 'md' });
    this.callApiBasedOnProjectType(this.projectID);
  }

  GetProfileDetails(){
    this.authService.GetProfileData().subscribe((resJSON: any) => {
        if (resJSON.code == 200) {
          // this.router.navigate(['/accounts/login']);
          // this.notificationService.showSuccess(`${resJSON.message}`, '');
        } else {
          this.notificationService.showError(`${resJSON.message}`, '');
        }
      });
  }

  navigateToExistingStep(stepIndex:number){
    setTimeout(() => {
      this.stepper.selectedIndex = stepIndex;
      this.activeStepIndex = stepIndex;

      switch (stepIndex) {
        case 0:
          this.stepContent = "content-1";
          break;
        case 1:
          this.stepContent = "content-2";
          break;
        case 2:
          this.stepContent = "content-3";
          break;
        case 3:
          this.stepContent = "content-4";
          break;
        case 4:
          this.stepContent = "content-5";
          break;
        default:
          this.stepContent = "";
      }

      // this.isLinear = true;
      this.cdr.detectChanges();
    }, 1000);
  }

  PatchUserData() {
    this.editProjectForm.patchValue({
      vProjectName: this.projects.vProjectName,
      vDescription: this.projects.vDescription
    });
  }

  updateStepContent(stepIndex: number) {
    // Update active step index
    this.activeStepIndex = stepIndex;

    this.isOnFinalStep = stepIndex === 4;

    // Update step statuses
    for (let i = 0; i < 5; i++) {
      const statusInfo = this.getStatus(i);
      const labelStatusTwo = document.getElementById(`label-status-two-${i}`);
      const stepLabel = document.getElementById(`stepLabel-${i}`);
      if (labelStatusTwo) {
        labelStatusTwo.innerHTML = statusInfo.status;
        labelStatusTwo.className = statusInfo.className;
      }
    }

    switch (stepIndex) {
      case 0:
        this.stepContent = "content-1";
        break;
      case 1:
        this.stepContent = "content-2";
        break;
      case 2:
        this.stepContent = "content-3";
        break;
      case 3:
        this.stepContent = "content-4";
        break;
      case 4:
        this.stepContent = "content-5";
        break;
      default:
        this.stepContent = "";
    }
  }

  getStatus(index: number): { status: string; className: string; completed: boolean } {
    let completed = false;

  if (this.isOnFinalStep && index < 4) {
    return { status: "Completed", className: "completed", completed: true };
  }

    if (index < this.activeStepIndex) {
      completed = true; 
    } else if (index === this.activeStepIndex) {
      switch (index) {
        case 2:
          completed = this.specificationsComponent?.updatepcbForm?.valid || false;
          break;
        default:
          completed = false;
      }
    }
  
    if (index < this.activeStepIndex || this.activeStepIndex==4) {
      let flag=this.isStepperFormsRoute();
      if(flag==false && this.activeStepIndex==4 && index == 4){
        return { status: "In Progress", className: "inProgress", completed };
      }else{
        return { status: "Completed", className: "completed", completed: true };
      }
    } else if (index === this.activeStepIndex) {
      return { status: "In Progress", className: "inProgress", completed };
    } else {
      return { status: "Pending", className: "pending", completed: false };
    }
  }

  CheckIfInvalid() {
    if (this.editProjectForm.invalid) {
      this.isFormInvalid = true;
    } else {
      this.isFormInvalid = false;
    }
  }

  EditProject() {
    this.editProjectFormSubmitted = true;

    // Check if the form is invalid
    if (this.editProjectForm.invalid) {
      // Display error messages for all fields
      Object.keys(this.editProjectForm.controls).forEach((field) => {
        const control = this.editProjectForm.get(field);
        if (control) {
          control.markAsTouched({ onlySelf: true });
        }
      });
      return;
    }

    const reqJSON: EditProject = {
      vProjectName: this.editProjectForm.value.vProjectName,
      vDescription: this.editProjectForm.value.vDescription
    };
    const id = localStorage.getItem('ID')
    // API Call Goes Here
    this.isLoading = true;
    this.quotingService.EditProject(id, reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.modalService.dismissAll();
        this.callApiBasedOnProjectType(this.projectID);
        this.editProjectForm.reset();
        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  navigateToStep(stepIndex: number) {
    if (this.activeStepIndex === 4 && stepIndex < 4) {
      return;
    }

    if (this.stepper) {
      this.isLinear = false;
      localStorage.setItem('currentStepIndex', stepIndex.toString());
    setTimeout(() => {
      this.stepper.selectedIndex = stepIndex;
      this.isLinear = true;
      this.cdr.detectChanges();
    }, 0);
    }
  }

  // Example method called from app-upload-files component
  skipToDesignView() {
    this.navigateToStep(2); // Navigate to the 3rd step (index 2)
  }

  CancelEditProfile() {
    this.editProjectForm.reset();
  }

  currentStep = 0;
  steps = [
    { label: 'Upload Files', status: 'Pending', completed: false },
    { label: 'Design View', status: 'Pending', completed: false },
    { label: 'Specifications', status: 'Pending', completed: false },
    { label: 'BoM Validation', status: 'Pending', completed: false },
    { label: 'Quotation & Order', status: 'Pending', completed: false }
  ];

  // Navigate to a specific step
  goToStep(index: number) {
    this.currentStep = index;
  }

  // Update the status and completion flag for a step
  updateStepStatus(index: number, status: string, completed: boolean) {
    this.steps[index].status = status;
    this.steps[index].completed = completed;
  }

  // Example function to skip to the next step
  // skipNextStep() {
  //   if (this.currentStep < this.steps.length - 1) {
  //     this.currentStep++;
  //   }
  // }
}
